import { LinkCard as RotaryOrgCardNPM } from '@rotaryintl/component-landing-pages';
import { Image, RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import { createLink } from '../../utilities/link-helpers';

const RotaryOrgCard = ({ fields: { IsFeatured, Link, Title, Description, Image: ImageField, Tag } = {} }) => (
  <RotaryOrgCardNPM
    colSpan={IsFeatured?.value === true ? '2' : '1'}
    tag={Tag?.fields?.Value?.value}
    link={createLink(Link, Title)}
    title={<Text field={Title} />}
    description={<RichText field={Description} />}
    image={ImageField?.value?.src && !ImageField?.value?.src.includes('default_image.svg') && <Image field={ImageField} />}
    backgroundColor="gray"
  />
);

export default withSitecoreContext()(RotaryOrgCard);